import { useState, useEffect } from "react";
import { Box, Stack, Typography, TextField, Button } from "@mui/material";
import request from "../../../utilities/requests";
import { toast } from "../../../utilities/SnackBarUtils";

const Messaging = ({ event }) => {
  const [ticketTerms, setTicketTerms] = useState("")
  const [webConfirm, setWebConfirm] = useState("");
  const [emailConfirm, setEmailConfirm] = useState("");

  const [loading, setLoading] = useState(false);
  const [savingTerms, setSavingTerms] = useState(false);
  const [savingWeb, setSavingWeb] = useState(false);
  const [savingEmail, setSavingEmail] = useState(false);

  useEffect(() => {
    if (event?._id) getConfig();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [event?._id]);

  const getConfig = async () => {
    try {
      setLoading(true);
      const result = await request(
        `events/config/?eventId=${event._id}&messaging=true`
      );
      if (result?.success && result?.data) {
        const config = result.data;
        if (config.ticketTerms !== undefined) {
          setTicketTerms(config.ticketTerms || "");
        }
        if (config.webConfirmation !== undefined)
          setWebConfirm(config.webConfirmation || "");
        if (config.emailConfirmation !== undefined)
          setEmailConfirm(config.emailConfirmation || "");
      }
    } catch (e) {
      // no-op; you can add error handling/snackbar if desired
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (field) => {
    try {
      const body = { eventId: event._id };
      if (field === "terms") {
        setSavingTerms(true)
        body.updates = { ticketTerms }
      } else if (field === "web") {
        setSavingWeb(true);
        body.updates = { webConfirmation: webConfirm };
      } else if (field === "email") {
        setSavingEmail(true);
        body.updates = { emailConfirmation: emailConfirm };
      }
      const result = await request("events/config", "post", body);
      if (result.success) {
        toast.success("Message updated");
      } else {
        toast.error(result.error);
      }
    } catch (e) {
      toast.error(e.message);
    }

    setSavingWeb(false);
    setSavingEmail(false);
  };


  return (
    <Box>
      <Stack spacing={3} sx={{pr: 3}}>
         <Box style={{marginTop: 20}}>
          <Typography variant="subtitle1" sx={{ mb: 1 }}>
            Ticket Purchase Terms & Conditions
          </Typography>
          <TextField
            fullWidth
            multiline
            minRows={10}
            value={ticketTerms}
            onChange={(e) => setTicketTerms(e.target.value)}
            placeholder="Ticket purchase terms shown during checkout"
            disabled={loading}
          />
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
            <Button
              variant="contained"
              onClick={() => handleSave('terms')}
              disabled={loading || savingTerms}
            >
              {savingTerms ? "Saving…" : "Save"}
            </Button>
          </Box>
        </Box>
        <Box >
          <Typography variant="subtitle1" sx={{ mb: 1 }}>
            Web Confirmation Message
          </Typography>
          <TextField
            fullWidth
            multiline
            minRows={10}
            value={webConfirm}
            onChange={(e) => setWebConfirm(e.target.value)}
            placeholder="Shown on the confirmation screen after purchase"
            disabled={loading}
          />
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
            <Button
              variant="contained"
              onClick={() => handleSave('web')}
              disabled={loading || savingWeb}
            >
              {savingWeb ? "Saving…" : "Save"}
            </Button>
          </Box>
        </Box>

        {/* Email confirmation editor */}
        <Box>
          <Typography variant="subtitle1" sx={{ mb: 1 }}>
            Email Confirmation Message
          </Typography>
          <TextField
            fullWidth
            multiline
            minRows={10}
            value={emailConfirm}
            onChange={(e) => setEmailConfirm(e.target.value)}
            placeholder="Body content for the confirmation email"
            disabled={loading}
          />
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
            <Button
              variant="contained"
              onClick={() => handleSave('email')}
              disabled={loading || savingEmail}
            >
              {savingEmail ? "Saving…" : "Save"}
            </Button>
          </Box>
        </Box>
      </Stack>
    </Box>
  );
};

export default Messaging;
